import { SentimentName } from 'v2/core/entities/fields';

export const getSentimentChipColor = (
  sentimentName: SentimentName | undefined,
) => {
  switch (sentimentName) {
    case SentimentName.POSITIVE:
      return 'sentiment.positive';
    case SentimentName.NEGATIVE:
      return 'sentiment.negative';
    default:
      return 'sentiment.neutral';
  }
};
